// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store/index'
import routerMethods from '@/router/routerMethods'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import 'vue-tree-halower/dist/halower-tree.min.css'
import { VTree, VSelectTree } from 'vue-tree-halower'
import 'font-awesome/css/font-awesome.css'
import './Global'

Vue.config.productionTip = false;

Vue.use(VTree);
Vue.use(VSelectTree);
Vue.use(routerMethods);
Vue.use(ElementUI, {size: 'medium'});
Vue.component('treeselect', Treeselect);

new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js